export default "__VITE_ASSET__BYBVlBDv__"